export const TIME_MANAGEMENT_TIMEZONE = 'America/Halifax';
export const TIME_MANAGEMENT_DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const WEEKLY_OVERTIME_MINUTES = 40 * 60;
export const LONG_SHIFT_MINUTES = 8 * 60;
export function formatTime(iso) {
    return new Date(iso).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: TIME_MANAGEMENT_TIMEZONE,
    });
}
export function formatDate(iso) {
    return new Date(iso).toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        timeZone: TIME_MANAGEMENT_TIMEZONE,
    });
}
export function formatDuration(clockIn, clockOut, nowMs = Date.now()) {
    const start = new Date(clockIn).getTime();
    const end = clockOut ? new Date(clockOut).getTime() : nowMs;
    return formatMinutes(Math.round((end - start) / 60000));
}
export function getTodayStr(now = new Date()) {
    return new Intl.DateTimeFormat('en-CA', { timeZone: TIME_MANAGEMENT_TIMEZONE }).format(now);
}
export function getWeekStart(dateStr) {
    const d = new Date(dateStr + 'T12:00:00');
    const day = d.getDay();
    const diff = day === 0 ? 6 : day - 1;
    d.setDate(d.getDate() - diff);
    return d;
}
export function formatWeekRange(start) {
    const end = new Date(start);
    end.setDate(end.getDate() + 6);
    const fmt = (d) => d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        timeZone: TIME_MANAGEMENT_TIMEZONE,
    });
    return `${fmt(start)} - ${fmt(end)}`;
}
export function getWeekDates(start) {
    return Array.from({ length: 7 }, (_, i) => {
        const d = new Date(start);
        d.setDate(d.getDate() + i);
        return new Intl.DateTimeFormat('en-CA', { timeZone: TIME_MANAGEMENT_TIMEZONE }).format(d);
    });
}
export function getMonthLabel(year, month) {
    return new Date(year, month - 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}
export function getMonthRange(year, month) {
    const lastDay = new Date(year, month, 0).getDate();
    return {
        startDate: `${year}-${String(month).padStart(2, '0')}-01`,
        endDate: `${year}-${String(month).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`,
    };
}
export function formatMinutes(mins) {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${h}h ${m}m`;
}
export function calculateDailyTotals(entries, nowMs = Date.now()) {
    return entries.reduce((acc, entry) => {
        const start = new Date(entry.clockIn).getTime();
        const end = entry.clockOut ? new Date(entry.clockOut).getTime() : nowMs;
        const mins = Math.round((end - start) / 60000);
        acc[entry.employee.name] = (acc[entry.employee.name] || 0) + mins;
        return acc;
    }, {});
}
export function downloadCsv(filename, content) {
    const blob = new Blob([content], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
